// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-deal-created-modal',
    templateUrl: './deal-created-modal.component.html',
    styleUrls: ['../error-modal/error-modal.component.scss'],
})
export class DealCreatedModalComponent {
    constructor(
        private dialogRef: MatDialogRef<DealCreatedModalComponent>,

        @Inject(MAT_DIALOG_DATA) public deal: any
    ) {}

    get message(): string {
        // deal was created, but there may still be an error adding documents
        if (this.deal?.createError) {
            return 'but some documents may not have been added properly. Please review your deal for any missing items, and if you continue to receive issues please contact the help desk.';
        } else {
            // If we got here everything passed successfully
            return 'and a welcome message has been sent to the buyer. If there is a Co-Buyer, a welcome message has been sent to them also.';
        }
    }

    close() {
        this.dialogRef.close();
    }
}
